import {
  Button,
  Col,
  Form,
  FormGroup,
  FormSelect,
  Modal,
  Row,
} from "react-bootstrap";
import FileUploader from "../../../../@ui/FileUploader";
import { Formik } from "formik";
import { triggerImportSchema } from "./schema";
import { ErrorText } from "../../../../@ui/ErrorText";
import styled from "styled-components";
import ThemedModal from "../../../../@ui/Modal/ThemedModal";
import LoadingSpinner from "../../../Loading/LoadingSpinner";

interface TriggerImportModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (description?: string, file?: File | null) => void;
  isSubmitting: boolean;
  hasErrored: boolean;
}

interface TriggerForm {
  osFile?: File | null;
  description?: string;
}

const StyledModalTitle = styled(Modal.Title)`
  font-size: 1.25rem;
`;

const TriggerImportModal = ({
  show,
  onClose,
  onSubmit,
  isSubmitting,
  hasErrored
}: TriggerImportModalProps) => {
  const submit = (values: TriggerForm) => {
    const { osFile, description } = values;
    onSubmit(description, osFile);
  };

  const initialValues: TriggerForm = {};

  return (
    <ThemedModal centered show={show} onHide={onClose}>
      <Formik
        onSubmit={submit}
        initialValues={initialValues}
        validationSchema={triggerImportSchema}
      >
        {({ handleSubmit, setFieldValue, setTouched, errors }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Header className="bg-secondary text-white" closeButton>
              <StyledModalTitle>Trigger OS POI Import</StyledModalTitle>
            </Modal.Header>
            <Modal.Body>
              <Row className="justify-content-center">
                <Col className="col-md-10">
                  <FormGroup className="w-100 mt-2">
                    <Form.Label>Upload OS POI Archive: </Form.Label>
                    <FileUploader
                      onClear={() => setFieldValue("osFile", undefined)}
                      onChange={(file) => {
                        setFieldValue("osFile", file);
                      }}
                      onBlur={(_) => setTouched({ osFile: true })}
                    />
                  </FormGroup>
                  {errors.osFile && (
                    <ErrorText className="text-danger">
                      OS POI file required
                    </ErrorText>
                  )}
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col className="col-md-10">
                  <FormGroup className="w-100 mt-2">
                    <Form.Label>Upload Description: </Form.Label>
                    <Form.Control
                      id="description"
                      name="description"
                      onChange={(e) => {
                        setFieldValue("description", e.target.value);
                      }}
                    />
                  </FormGroup>
                  {errors.description && (
                    <ErrorText className="text-danger">
                      Description is required
                    </ErrorText>
                  )}
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              {!hasErrored && <>
                {isSubmitting && <span className="text-warning">This might take a while, <i>don't refresh</i></span>}
                <Button disabled={isSubmitting} onClick={() => { }} type="submit" variant="primary">
                  {!isSubmitting && <>Trigger Import</>}
                  {isSubmitting && <><LoadingSpinner textColor="text-light" /></>}
                </Button></>}
              {hasErrored && <><span className="text-danger">These has been an error attempting to start the import!</span></>}
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </ThemedModal>
  );
};

export default TriggerImportModal;
